<template>
    <div
        v-if="contacts && contacts.length"
        class="contacts-block pl-8 pl-md-0 d-flex align-md-center flex-wrap flex-column flex-sm-row align-start gc-3"
        :class="{'full-width': $breakpoint.smAndDown}"
    >
        <div
            v-for="contact in contacts"
            :key="contact.description"
            class="d-flex flex-column flex-md-row justify-space-between text-caption text-lg-body-2 gc-2"
            :class="{'full-width': $breakpoint.smAndDown}"
        >
            <span
                v-if="contact.description"
                class="nowrap"
                :class="{'text-white': $breakpoint.smAndDown}"
                v-text="contact.description"
            />
            <div v-if="contact.phone" class="d-flex align-center">
                <v-icon v-if="isShowIcons" size="x-small" class="me-1">mdi-cellphone</v-icon>
                <a class="text-decoration-none nowrap" :href="`tel:${contact.phone}`" v-text="contact.phone" />
            </div>
            <div v-if="contact.email" class="d-flex align-center">
                <v-icon v-if="isShowIcons" size="x-small" class="me-1">mdi-at</v-icon>
                <a
                    class="text-decoration-none"
                    :class="{'nowrap overflow-hidden': $breakpoint.smAndDown}"
                    style="text-overflow: ellipsis"
                    :href="`mailto:${contact.email}`"
                    v-text="contact.email"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ContactsBlock extends Vue {
        isShowIcons = false

        get contacts() {
            return cmsStore.layoutSettings.contacts
        }
    }

    export default ContactsBlock
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';
    @media #{map.get(settings.$display-breakpoints, 'md-and-down')} {
        .contacts-block {
            width: min-content;
        }
    }
</style>
